import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vacationsAbsencesDelegationsComponent from './vacationsAbsencesDelegations.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let vacationsAbsencesDelegationsModule = angular.module('vacations-absences.vacationsAbsencesDelegations', [
  uiRouter,
])

.component('vacationsAbsencesDelegations', vacationsAbsencesDelegationsComponent)

.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state(STATES.VACATIONS_ABSENCES.DELEGATE, {
      url: ROUTES.VACATIONS_ABSENCES.DELEGATE,
      component: 'vacationsAbsencesDelegations',
      data: {
        requiresAuth: true,
        requiresManager: true,
      },
    });
})
.name;

export default vacationsAbsencesDelegationsModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/vacationsAbsencesDelegations/vacationsAbsencesDelegations.js